import { render, staticRenderFns } from "./fdlerates.vue?vue&type=template&id=533aab0e&scoped=true&"
import script from "./fdlerates.vue?vue&type=script&lang=js&"
export * from "./fdlerates.vue?vue&type=script&lang=js&"
import style0 from "./fdlerates.vue?vue&type=style&index=0&id=533aab0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533aab0e",
  null
  
)

export default component.exports